import { Results } from '@atlassian/cssxp-typescommon';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { CommerceNoteSearchParams, CommerceNoteSearchOptions, CommerceNoteResults } from '@atlassian/cssxp-types-audit';
import { Refund, RefundSearchParams } from '@atlassian/cssxp-types-billing';
import { PDFStatus } from '../quotes/quotes';

const client = createAxiosClient({ baseURL: '/api/1/refunds' }, ServiceProxyMap.ANS);

export interface DownloadCreditNoteResponseDto {
  pdfUrl?: string;
  pdfStatus: PDFStatus;
}

export async function searchRefunds(searchParams: RefundSearchParams): Promise<Results<Refund>> {
  const result = await client.get('/', {
    params: searchParams,
  });

  return result.data;
}

export async function fetchRefund(refundId: string): Promise<Refund> {
  const result = await client.get(`/${refundId}`);
  return result.data;
}

export async function searchCommerceNotesRefunds(
  refundKey: string,
  params: Omit<CommerceNoteSearchParams, 'refundKey'> & CommerceNoteSearchOptions
): Promise<CommerceNoteResults> {
  const response = await client.get(`/${encodeURIComponent(refundKey)}/notes`, {
    params,
  });
  return response.data;
}

export async function downloadCreditNotePDF(
  creditNoteId: string,
  transactionAccountId: string
): Promise<DownloadCreditNoteResponseDto> {
  const response = await client.get(`/${creditNoteId}/download`, {
    params: { transactionAccountId },
  });
  return response?.data;
}
